import { Usuario } from "@/shared/dtos/usuario";

export class UsuarioAllDto extends Usuario {
}
